import { FC, ReactNode } from 'react'
import { GRAY_900, WHITE } from 'constants/styling/theme'
import { SxProps, Theme } from '@mui/material/styles'

import Button from '@mui/material/Button'

interface Props {
  label: string
  onClick: () => void
  startIcon?: ReactNode
  sx?: SxProps<Theme>
}

export const StartConversationButton: FC<Props> = ({ label, onClick, startIcon, sx }) => (
  <Button
    fullWidth
    variant="contained"
    startIcon={startIcon}
    onClick={onClick}
    sx={[
      {
        backgroundColor: GRAY_900,
        color: WHITE,
        textTransform: 'none',
        borderRadius: '999px',
        padding: '1.2rem',
        fontSize: '1.5rem',
        fontWeight: 500,
        boxShadow: 'none',
        '&:hover': { backgroundColor: GRAY_900, opacity: 0.92, boxShadow: 'none' },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {label}
  </Button>
)
